import type { GridColDef, GridSortModel } from '@mui/x-data-grid-pro';
import type { SortDto } from '@tempo-io/roadmap-dto';
import { dequal } from 'dequal';
import * as React from 'react';
import { buildTableColumnField, parseTableColumnField } from './tableColumnUtils';

export type OnSortModelChange = (sort: SortDto) => void;

export const useSortModel = (
  sort: SortDto | undefined,
  onSortModelChange: OnSortModelChange | undefined,
  columns: Pick<GridColDef, 'field' | 'sortable'>[],
) => {
  const { type, customFieldId, order } = sort ?? {};
  const [initialSortModel] = React.useState<GridSortModel>(() => {
    if (!type) return [];
    const field = buildTableColumnField({ type, customFieldId });
    const column = columns.find((c) => c.field === field);
    if (!column || column.sortable === false) return [];
    return [{ field, sort: order }];
  });

  const onItemsTableSortModelChange = onSortModelChange
    ? (newSortModel: GridSortModel) => {
        const firstSortItem = newSortModel[0];
        const newSort: SortDto = firstSortItem
          ? {
              ...parseTableColumnField(firstSortItem.field),
              order: firstSortItem.sort === 'desc' ? 'desc' : 'asc',
            }
          : { type: 'customField', customFieldId: null, order: 'asc' };

        if (!dequal(sort, newSort)) {
          onSortModelChange(newSort);
        }
      }
    : undefined;

  return { initialSortModel, onItemsTableSortModelChange };
};
